/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/search-offblack.json";

export const IllustrativeIconSearchOffblack = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIconSearchOffblack.displayName = "IllustrativeIconSearchOffblack";
